import { axios } from '../../../axios'

export const getProfile = (params = {}) => {
  return axios.get('/auth/profile', { params }).then(({ data }) => data)
}

export const updateProfile = (params = {}) => {
  return axios.put('/auth/profile/', params).then(({ data }) => data)
}
